import React from "react";
import { Button } from "reactstrap";
import PropTypes from "prop-types";
import { walletConnect } from "@bkry/bowline-connectors";
import { URI_AVAILABLE } from "@web3-react/walletconnect-v2";
import { setKeepWalletConnection } from "@bkry/bowline-redux/wallets";
import { useDispatch } from "react-redux";
import { getEnv } from "@bkry/bowline-utils";

const WalletConnectButton = (props, context) => {
  const REACT_APP_MAINNET = getEnv("REACT_APP_MAINNET");
  const dispatch = useDispatch();
  const { suggestedChainId } = props;
  const chainId = suggestedChainId
    ? suggestedChainId
    : REACT_APP_MAINNET
    ? 1
    : 11155111;

  const handleConnect = () => {
    if (walletConnect) {
      walletConnect
        .activate(chainId)
        .then(() => {
          dispatch(
            setKeepWalletConnection({
              keepWalletConnection: true,
              lastProvider: "wallet-connect",
            })
          );
        })
        .catch((err) => console.error(err));
    }
  };

  return (
    <Button onClick={handleConnect} className="mb-3" color="primary" size="lg">
      {context.t("Connect with Wallet Connect")}
    </Button>
  );
};

/**  define proptype for the 'translation' function  */
WalletConnectButton.contextTypes = {
  t: PropTypes.func,
};

export default WalletConnectButton;
